import { ActivatedRouteSnapshot, RedirectCommand, ResolveFn } from '@angular/router';
import { NoteService } from '../services/note_service';
import { UserService } from '../services/user_service';
import { inject } from '@angular/core';

export const NotePurchaseStatusResolve: ResolveFn<number | RedirectCommand | null> = (
  route: ActivatedRouteSnapshot
) => {
  const userService = inject(UserService);
  const noteService = inject(NoteService);

  const getNoteStatus = (noteId: string): Promise<number | null> => {
    return Promise.allSettled([
      noteService.getNotePurchaseStatus(noteId),
      userService.getProfile()
    ]).then(results => {
      const statusResult = results[0];
      const userResult = results[1];
      
      let hasAccess = false;
      let isAdmin = false;

      if (statusResult.status === 'fulfilled' && statusResult.value) {
        hasAccess = statusResult.value.hasOwnProperty('hasAccess') && statusResult.value['hasAccess'];
      }

      if (userResult.status === 'fulfilled' && userResult.value) {
        isAdmin = !!userResult.value['admin']; 
      }
      
      return (isAdmin || hasAccess) ? 1 : 402;
    })
    .catch(err => {
      console.error('An unexpected error occurred during status check', err);
      return null;
    });
  };

  if (route.params['custom-url']) {
    const customUrl = route.params['custom-url'];
    return noteService.getNoteIdFromCustomUrl(customUrl)
      .then(result => getNoteStatus(result.post.id))
      .catch(err => {
          console.error('Error fetching note ID from custom URL', err);
          return null;
      });
  } else {
    return getNoteStatus(route.params['id']);
  }
};